import state from './state'
import mutations from "@/store/mutations";
import actions from './actions'

const
    fee = {
        namespaced: true,
        state,
        actions,
        mutations
    }
export default fee